export default __webpack_public_path__ + "static/media/login-bg.f8873827.png";